import { Button, ButtonGroup, Grid, Modal } from '@design-systems/canvas-ui'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { useEssentials } from 'hooks/utils/useEssentials'
import { PreferredMap } from 'types/user-context'

type MapModalProps = {
    isVisible: boolean
    onHide: () => void
    selectedMap: PreferredMap
    onMapSelect: (map: PreferredMap) => void
    onContinue: () => void
    isLoading: boolean
}

export const MapModal = ({
    isVisible,
    onHide,
    selectedMap,
    onMapSelect,
    onContinue,
    isLoading,
}: MapModalProps) => {
    const { t } = useEssentials()
    const { settings, common } = TRANSLATION_KEYS

    return (
        <Modal
            isOpen={isVisible}
            onClose={onHide}
            headingText={t(settings.preferredMap)}
            className="hc8-ml-6x hc8-mr-6x"
        >
            <div className="hc8-pa-3x">
                <Grid.Container>
                    <Grid.Item
                        className="hc8-mb-3x"
                        size={{
                            xs: 12,
                        }}
                    >
                        <span>{t(settings.mapMessage)}</span>
                    </Grid.Item>
                    <Grid.Item>
                        <ButtonGroup className="hc8-mb-6x">
                            <Button
                                className={`${selectedMap === 'Apple' ? 'lang-active' : ''}`}
                                onClick={() => onMapSelect('Apple')}
                                size="lg"
                            >
                                {t(settings.maps.apple)}
                            </Button>
                            <Button
                                className={`${selectedMap === 'Google' ? 'lang-active' : ''}`}
                                onClick={() => onMapSelect('Google')}
                                size="lg"
                            >
                                {t(settings.maps.google)}
                            </Button>
                        </ButtonGroup>
                    </Grid.Item>
                </Grid.Container>
                <Grid.Container direction="row-reverse" spacing="dense">
                    <Grid.Item>
                        <Button
                            onClick={onContinue}
                            isLoading={isLoading}
                            variant="primary"
                        >
                            {t(common.continue)}
                        </Button>
                    </Grid.Item>
                    <Grid.Item>
                        <Button onClick={onHide} variant="secondary">
                            {t(common.cancel)}
                        </Button>
                    </Grid.Item>
                </Grid.Container>
            </div>
        </Modal>
    )
}
